__turbopack_context__.v({
  "container": "Breadcrumbs-module-scss-module__lyJFPa__container",
  "lastItem": "Breadcrumbs-module-scss-module__lyJFPa__lastItem",
  "list": "Breadcrumbs-module-scss-module__lyJFPa__list",
  "listItem": "Breadcrumbs-module-scss-module__lyJFPa__listItem",
});
